import { render } from "./FranchiseInvestment.vue?vue&type=template&id=6db42a94&scoped=true&ts=true"
import script from "./FranchiseInvestment.vue?vue&type=script&lang=ts"
export * from "./FranchiseInvestment.vue?vue&type=script&lang=ts"

import "./FranchiseInvestment.vue?vue&type=style&index=0&id=6db42a94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db42a94"]])

export default __exports__